import { render, staticRenderFns } from "./InputWithSuggestion.vue?vue&type=template&id=99288a96&scoped=true&"
import script from "./InputWithSuggestion.vue?vue&type=script&lang=js&"
export * from "./InputWithSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./InputWithSuggestion.vue?vue&type=style&index=0&id=99288a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99288a96",
  null
  
)

export default component.exports